module.exports = __webpack_public_path__ + "assets/img/download.cc3a872d.svg";